import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

export default styled.div`
	display: flex;
	align-items: center;
	.empty-label {
		white-space: normal;
	}
`;

export const StyledPspPadding = styled(OutputText)`
	padding-left: var(--spacing-medium);
`;
